var moduleMap = {
	"./pages-map": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map */ 19).then(function() { return function() { return (__webpack_require__(9500)); }; });
	},
	"./pages-map-v2": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map_v2 */ 974).then(function() { return function() { return (__webpack_require__(4180)); }; });
	},
	"./pages/index": function() {
		return Promise.all(/* __federation_expose_pages__index */[__webpack_require__.e(30), __webpack_require__.e(724), __webpack_require__.e(786), __webpack_require__.e(814)]).then(function() { return function() { return (__webpack_require__(8384)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});